// axios
import axios from 'axios'
import store from './store'

const baseURL = '/api/installer/v1'

const instance = axios.create({
    baseURL: baseURL
    // You can add your headers here
})

instance.interceptors.request.use(
    (config) => {
        if (store.state.authToken.length > 0) {
            config.headers.Authorization = `Bearer ${store.state.authToken}`
        }
        return config
    },

    (error) => {
        return Promise.reject(error)
    }
)

export default instance
